export default "__VITE_ASSET__DRfRDx98__"